module.exports = "<div class=\"user-details-component user-children\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      CHILDREN\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"children-grid\">\r\n      <div id=\"children-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-children/user-children.html
 ** module id = 602
 ** module chunks = 0
 **/